import { ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideClientHydration } from '@angular/platform-browser';
import { AppHttpInterceptor } from './core/interceptors/app-http-interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideEffects } from '@ngrx/effects';
import { appEffects, appStore } from './store/app.state';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { ErrorHandler, Injectable } from '@angular/core';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from 'environments/environment';

@Injectable()
class CustomErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    if (
      error instanceof TypeError &&
      error?.message?.includes('Failed to fetch dynamically imported module')
    ) {
      const messageArr = error.message.split('.routes');
      let route = '';
      if (messageArr[0]) {
        const pathArr = messageArr[0].split('/');
        route = pathArr[pathArr.length - 1];
      }

      setTimeout(() => {
        if (route) {
          window.location.href = window.location.origin + Menus[route];
        } else {
          window.location.reload();
        }
      }, 100);
    }
  }
}

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    provideStore(appStore),
    provideEffects(appEffects),
    provideAnimations(),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(),
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
      trace: false, //  If set to true, will include stack trace for every dispatched action, so you can see it in trace tab jumping directly to that part of code
      traceLimit: 75, // maximum stack trace frames to be stored (in case trace option was provided as true)
    }),
    importProvidersFrom(HttpClient),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppHttpInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    { provide: ErrorHandler, useClass: CustomErrorHandler },
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
        extend: true,
      })
    ),
    importProvidersFrom(
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: environment.production,
      })
    ),
  ],
};

const Menus: { [key: string]: string } = {
  dashboard: '/dashboard',
  contracts: '/contracts',
  manage: '/manage',
  settings: '/settings',
  reports: '/reports',
};
